
import Promise from "plugins/bluebird"

function getNoty() {
  return Promise.resolve(
    import(
      "noty"
    )
    .then(({default: Noty}) => {
      Noty.overrideDefaults({
        timeout:  8000,
        layout:   "topCenter",
        theme:    "sunset",
      })

      return Noty
    }),
  )
}

export {
  getNoty,
}
